import {
	SHOW_HIDE_LOADER
} from '../actions/types'; 

const initialState = false;

export default function loaderReducer(state=initialState, action) {
    switch(action.type) {
        case SHOW_HIDE_LOADER:
            return action.payload.showLoader;
    };
    return state;
}